// import utils
import { TimePeriod } from 'utils/date';
import { startOfToday } from 'date-fns';
import dayjs from 'dayjs';

export const addHoursAndMinutes = (
  timePeriod: TimePeriod,
  hoursToAdd = 0,
  minutesToAdd = 0
): TimePeriod => {
  const today = startOfToday();
  const [initialHours, initialMinutes] = timePeriod.split(':');
  today.setHours(parseInt(initialHours, 10), parseInt(initialMinutes, 10));

  return dayjs(today)
    .add(hoursToAdd, 'hours')
    .add(minutesToAdd, 'minutes')
    .format('HH:mm') as TimePeriod;
};
